import { Record as record } from 'immutable';
import _ from 'lodash';
import Joi from 'joi';

import config from '../../config';
import { translate as t } from '../../lib/I18n';
import validation from '../../validation';
import ValidationMixin from '../ValidationMixin';

const customerTitles = config.get('customerTitles') || [];
class LeadPassenger extends record({ title: customerTitles[0], initial: null, surname: null }) {

    static fromJSON(json = {}) {
        //HACK: Handle cocs using a single field for lead passenger
        if (_.isString(json)) {
            const parts = json.split(" ");
            return new LeadPassenger({
                title: parts.shift(),
                initial: parts.shift(),
                surname: parts.join(" ")
            });
        }
        return new LeadPassenger(json);
    }

    getSchema () {
        return {
            title: validation.title(),
            initial: Joi.string().trim().required().min(1).max(1).messages({
                'any.required': t('alertmessage.string.max', { num: 1 }),
                'string.base': t('alertmessage.string.max', { num: 1 }),
                'string.min': t('alertmessage.string.max', { num: 1 }),
                'string.max': t('alertmessage.string.max', { num: 1 }),
            }),
            surname: validation.name()
        };
    }

    toString () {
        return `${this.title} ${this.initial} ${this.surname}`;
    }
}


Object.assign(LeadPassenger.prototype, ValidationMixin);


export default LeadPassenger;
